import '../styles/PageGlobal.css';
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TVAStateService } from '../services/TVAStateService.js';

export default function TVAStateListPage() {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStates = useCallback(async () => {
    const service = new TVAStateService();
    setLoading(true);
    try {
      const data = await service.getAllTVAStates();
      setStates(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchStates(); }, [fetchStates]);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cet État TVA ? Attention, cela peut affect les TVA liées.")) return;
    try {
      await new TVAStateService().deleteTVAState(id);
      fetchStates();
    } catch (err) {
      alert(err.message);
    }
  };

    const handleDeleteAll = async () => {
    if (!window.confirm("⚠️ ATTENTION : Cela va supprimer DÉFINITIVEMENT tous les États/Pays TVA. Continuer ?")) return;
    try {
      const message = await new TVAStateService().deleteAllTVAStates();
      alert(message);
      fetchStates();
    } catch (err) {
      alert(err.message); // Affichera le message propre si des TVA existent encore
    }
  };
  
  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="tva-error">{error}</div>;

  return (
    <div className="containerMain tva-container">
      <h1 className="tva-title">Gestion des États / Pays TVA</h1>
      
      <div className="tva-table-wrapper">
        <table className="tva-table">
          <thead>
            <tr>
              <th>N</th>
              
              <th>Label / Pays</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {states.map((state, index) => (
              <tr key={state.id}>
                <td>{index + 1}</td>
               
                <td>{state.label || ''}</td>
                <td className="tva-action-cell">
                  <button className="tva-btn tva-btn-yellow" onClick={() => navigate(`/tva-state-edit/${state.id}`)}>Edit</button>
                  <button className="tva-btn tva-btn-red" onClick={() => handleDelete(state.id)}>Suppr.</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="tva-bottom-actions">
        <button className="tva-btn tva-btn-blue" onClick={() => navigate('/tva-state-new')}>+ Nouvel État / Pays</button>
        <button className="tva-btn tva-btn-grey" onClick={() => navigate('/tva_list')}>Retour aux TVA</button>
        <button className="tva-btn tva-btn-red" onClick={handleDeleteAll} style={{ fontWeight: 'bold' }}>
      ️ Supprimer TOUS les États TVA
    </button>
      </div>
    </div>
  );
}